import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const SUPPORTED_LANGUAGES = ["en", "sv"] as const;
type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export function useLanguage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();

  useEffect(() => {
    const pathSegments = location.pathname.split("/").filter(Boolean);
    const currentLang = pathSegments[0] as SupportedLanguage;

    // Handle invalid or missing language in URL
    if (!SUPPORTED_LANGUAGES.includes(currentLang)) {
      // Reconstruct path: remove invalid language and ensure 'en' is at the start
      const validPath = pathSegments
        .filter((segment) => segment !== currentLang)
        .join("/");
      const newPath = `/en/${validPath}`;
      navigate(newPath, { replace: true });
      return;
    }

    // Change language if needed
    if (i18n.language !== currentLang) {
      i18n.changeLanguage(currentLang);
    }

    document.documentElement.lang = currentLang;
    document.title = `Refurbly ${t("pageTitle")}`;
  }, [location.pathname, i18n, navigate, t]);

  return i18n.language as SupportedLanguage;
}
